export const PoemFullOfLife = () => {
    return (
        <div id="032" className="">
            <p>heavy rain evening,</p>
            <p>soot grey everything,</p>
            <p>spider web everything,</p>
            <p>sticky soul, a present moment frayed,</p>
            <p>what's the opposite of release?</p>
            <p>is it safekeeping?</p>
            <p>is it holding by force or</p>
            <p>holding despite aiming to let go?</p>
            <p>regardless of my protests, i think everything makes sense,</p>
            <p>the walls are covered</p>
            <p>in small things that escape the web,</p>
            <p>return the favor,</p>
            <p>live life inside a halo shaped hole,</p>
            <p>the room is covered</p>
            <p>in traces of attempts to rewrite history.</p>
            <br />
            <p>small halo,</p>
            <p>the feeling's in my neck and in my back,</p>
            <p>the tiredness,</p>
            <p>the air you breathe contains these particles of dust,</p>
            <p>the fabric of the story,</p>
            <p>frayed at the edges and the elbows,</p>
            <p>i dread the present,</p>
            <p>i dread these dry paint looking moments,</p>
            <p>dread the stillness,</p>
            <p>and yet some parts of me refuse anything that might mean</p>
            <p>a chance of getting sullied,</p>
            <p>and so the clothes are hanging on the rack,</p>
            <p>unfrayed, unstained but most of all unworn.</p>
            <p>rewrite the present, do it by force,</p>
            <p>
                try blinking fifty thousand times until the corners of your eyes
            </p>
            <p>have those</p>
            <p>little spider web shaped wrinkles,</p>
            <p>that incidentally just look so full of life.</p>
        </div>
    );
};
